import { render, staticRenderFns } from "./AreaAmchart.vue?vue&type=template&id=a99e3694&scoped=true"
import script from "./AreaAmchart.vue?vue&type=script&lang=ts"
export * from "./AreaAmchart.vue?vue&type=script&lang=ts"
import style0 from "./AreaAmchart.vue?vue&type=style&index=0&id=a99e3694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99e3694",
  null
  
)

export default component.exports